import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function RouteNavigation() {
  const { pathname, hash, key } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Preserve links bookmarked before Services and Industries became pages.
    if (pathname === "/" && ["#services", "#industries"].includes(hash)) {
      navigate(`/${hash.slice(1)}`, { replace: true });
      return;
    }
    const titles = {
      "/": "GuruTech AI | Custom AI Solutions",
      "/services": "AI Development Services | GuruTech AI",
      "/industries": "Industries We Serve | GuruTech AI",
    };
    if (titles[pathname]) document.title = titles[pathname];
    const frame = requestAnimationFrame(() => {
      const target = hash ? document.getElementById(decodeURIComponent(hash.slice(1))) : null;
      if (target) target.scrollIntoView({ behavior: "instant", block: "start" });
      else window.scrollTo({ top: 0, behavior: "instant" });
    });
    return () => cancelAnimationFrame(frame);
  }, [pathname, hash, key, navigate]);
  return null;
}
